import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { AuditsApi } from "../../../apis/audits.api";
import moment from "moment";
import { DataType } from "@rightship-tech/common-ui/models/queries.models";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import * as DOMPurify from 'dompurify';
import { UserClientService } from "@rightship-tech/common-ui/services/basic/user-client.service";
import { UserClaimsService } from "@rightship-tech/common-ui/services/basic/user-claims.service";
import { Claims } from "@rightship-tech/common-ui/constants/authentication/claims";

@autoinject
@transient()
export class DialogAudits {

    private _documentId : number;
    private _documentTypeId : number;
    public audits: any;
    public isLoading: boolean = true;
    private isRsUser: boolean = false;

    constructor(public dialogClientService: DialogClientService, private auditsApi: AuditsApi, private configService: ConfigService,
        private userClientService: UserClientService, private userClaimsService: UserClaimsService
    ) {
        this.isRsUser = this.userClaimsService.hasPermission(Claims.RightShipUser);
    }

    activate(model: { documentId : number, documentTypeId : number }) {
        this._documentId = model.documentId;
        this._documentTypeId = model.documentTypeId
    }

    async attached() {

        try {

            //Get audits
            const response = await this.auditsApi.getDocumentAudits(this._documentId, this._documentTypeId);

            if(!this.isRsUser)
            {
                const currntCustomerId = this.userClientService?.currentUser?.businessUnit?.customerId;
                this.audits = response?.value.filter(audit => {
                    const customerId = this.getCustomerId(audit);
                    const relatedCustomerId = this.getRelatedCustomerId(audit);
                    return (audit.action.indexOf('marked as') == -1 // not review history
                        && customerId == null && relatedCustomerId == null) // no customer id
                    || customerId == currntCustomerId || relatedCustomerId == currntCustomerId // history of current user's customer
                    }
                );
            }
            else {
                this.audits = response?.value;
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.isLoading = false;
        }
    }

    //Close
    close() {
        this.dialogClientService.hide();
    }

    formatDate(date: string | Date) {
        return moment(date).format('DD MMM YYYY HH:mm');
    }

    getCustomerId(item) {
        const actionDetails = item.actionDetails;

        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(actionDetails);

        const span = div.querySelector("span[id='customer-id']");
        const customerId = Number(span?.getAttribute('data-value'));
        
        return isNaN(customerId) ? null : customerId;
    }

    getRelatedCustomerId(item) {
        
        const actionDetails = item.actionDetails;

        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(actionDetails);

        const span = div.querySelector("span[id='related-customer-id']");
        const customerId = Number(span?.getAttribute('data-value'));
        
        return isNaN(customerId) ? null : customerId;
    }

    getAuditBy(item)
    {
        const actionDetails = item.actionDetails;

        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(actionDetails);

        let customerName: string = null;
        const customerNameSpan: Element = div.querySelector("span[id='customer-name']");
        if(customerNameSpan)
        {
            customerName = customerNameSpan?.getAttribute('data-value');
        }
        
        //fallback, if customer id has value and is same as current user's customer id, use current user's customer name
        if(!customerName)
        {
            const customerIdSpan = div.querySelector("span[id='customer-id']");
            const customerId = Number(customerIdSpan?.getAttribute('data-value'));

            if(customerId == this.userClientService?.currentUser?.businessUnit?.customerId)
            {
                customerName = this.userClientService?.currentUser?.businessUnit?.customerName;
            }
        }

        return `By ${item.userName ? item.userName + (customerName? ", " + customerName: "") : 'System'}`;
    }

    getActionDetails(item) {
        const actionDetails = item.actionDetails;

        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(actionDetails);

        let spans: Element[] = Array.from(div.querySelectorAll("span[data-type='12']"));
        spans = spans.concat(Array.from(div.querySelectorAll("span[data-type='7']")));
        
        spans.forEach(span => {
            const value = span.textContent;
            const date = moment.utc(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY H:mm:ss", "DD/MM/YYYY hh:mm:ss A", "DD/MM/YYYY h:mm:ss A"]).local();
            const parameters = span.getAttribute('parameters');

            const dataType = Number(span.getAttribute('data-type'));
            let datestring = null;

            if (parameters && parameters != null && parameters != "") {
                datestring = date.format(parameters);
            }
            else {
                datestring = date.format(dataType == DataType.Date ? this.configService.config.common.defaultDateFormat : this.configService.config.common.defaultDateTimeFormat);
            }
            span.textContent = datestring;
        });

        return div.innerHTML;
    }
}
